import { render, staticRenderFns } from "./archives.vue?vue&type=template&id=6fd44bb3&scoped=true&"
import script from "./archives.vue?vue&type=script&lang=js&"
export * from "./archives.vue?vue&type=script&lang=js&"
import style0 from "./archives.vue?vue&type=style&index=0&id=6fd44bb3&prod&lang=scss&scoped=true&"
import style1 from "./archives.vue?vue&type=style&index=1&id=6fd44bb3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd44bb3",
  null
  
)

export default component.exports